import React from "react";
import Container from "../components/Container";
import InputName from "../components/InputName/InputName";

export default function HomeView() {
  return (
    <Container>
      <InputName />
    </Container>
  );
}
